import React, { useState, useEffect } from "react";
import api from "../../../services/api";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Paper,
  Divider,
  Fade,
  Radio,
  Checkbox,
  TextField,
  InputAdornment,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import {
  FileDownload as DownloadIcon,
  FilterAlt as FilterIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";

const PremiumCard = styled(Card)({
  background: "#ffffff",
  borderRadius: "16px",
  //boxShadow: "0 10px 30px rgba(60, 8, 217, 0.05)",
  border: "1px solid rgba(226, 232, 240, 0.8)",
  backdropFilter: "blur(20px)",
});

const ReportHeader = styled(Box)({
  background: "linear-gradient(135deg, #052467ff 0%, #1d4ed8 100%)",
  padding: "20px 32px", // Reduced padding height
  borderRadius: "20px",
  color: "#ffffff",
  marginBottom: "32px",
  boxShadow: "0 10px 30px rgba(37, 99, 235, 0.15)",
});

const formatDate = (dateStr) => {
  if (!dateStr) return "N/A";
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  } catch (error) {
    return dateStr;
  }
};

const AdminStudentReport = () => {
  // Filters: Cohort (Single Select with Radio), Corporate (Multi Select with Checkbox), Domain (Multi Select with Checkbox)
  const [cohortFilter, setCohortFilter] = useState("");
  const [corporateFilter, setCorporateFilter] = useState([]);
  const [domainFilter, setDomainFilter] = useState([]);




  const [courseAccessAdvance, setCourseAccessAdvance] = useState("");
  const [completionAdvance, setCompletionAdvance] = useState("");
  const [stateAdvance, setStateAdvance] = useState([]);
  const [cityAdvance, setCityAdvance] = useState([]);
  const [instituteAdvance, setInstituteAdvance] = useState([]);
  const [branchAdvance, setBranchAdvance] = useState([]);
  const [streamAdvance, setStreamAdvance] = useState([]);
  const [finalYearAdvance, setFinalYearAdvance] = useState([]);
  const [casteAdvance, setCasteAdvance] = useState([]);
  const [pwdAdvance, setPwdAdvance] = useState([]);
  const [ewsAdvance, setEwsAdvance] = useState([]);

  const [selectedAdvanceFilters, setSelectedAdvanceFilters] = useState([]);
  const [advanceFilterSearch, setAdvanceFilterSearch] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableSearch, setTableSearch] = useState("");
  const [tablePage, setTablePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    setTablePage(0);
  }, [tableSearch]);

  // Clear table data whenever any filter selection changes, forcing user to click Apply
  useEffect(() => {
    setShowTable(false);
    setTableData([]);
    setTotalCount(0);
  }, [
    cohortFilter,
    corporateFilter,
    domainFilter,
    courseAccessAdvance,
    completionAdvance,
    stateAdvance,
    cityAdvance,
    instituteAdvance,
    branchAdvance,
    streamAdvance,
    finalYearAdvance,
    casteAdvance,
    pwdAdvance,
    ewsAdvance
  ]);

  const advanceFilterOptions = [
    { value: "course access", label: "Course Access" },
    { value: "completion", label: "Completion" },
    { value: "state", label: "State" },
    { value: "city", label: "City" },
    { value: "institute", label: "Institute" },
    { value: "stream", label: "Stream" },
    { value: "branch", label: "Branch" },
    { value: "final year", label: "Final Year" },
    { value: "caste", label: "Caste" },
    { value: "pwd", label: "PWD" },
    { value: "ews", label: "EWS" }
  ];

  const advanceFilterOptionsFiltered = advanceFilterOptions.filter(opt =>
    opt.label.toLowerCase().includes(advanceFilterSearch.toLowerCase())
  );

  const handleAdvanceFilterToggleChange = (event) => {
    const {
      target: { value },
    } = event;

    if (value.includes("select-all")) {
      const allVals = ["course access", "completion", "state", "city", "institute", "stream", "branch", "final year", "caste", "pwd", "ews"];
      const isAllSelected = allVals.every(val => selectedAdvanceFilters.includes(val));
      if (isAllSelected) {
        setSelectedAdvanceFilters([]);
      } else {
        setSelectedAdvanceFilters(allVals);
      }
    } else {
      setSelectedAdvanceFilters(typeof value === "string" ? value.split(",") : value);
    }
  };

  useEffect(() => {
    if (!selectedAdvanceFilters.includes("course access")) setCourseAccessAdvance("");
    if (!selectedAdvanceFilters.includes("completion")) setCompletionAdvance("");
    if (!selectedAdvanceFilters.includes("state")) setStateAdvance([]);
    if (!selectedAdvanceFilters.includes("city")) setCityAdvance([]);
    if (!selectedAdvanceFilters.includes("institute")) setInstituteAdvance([]);
    if (!selectedAdvanceFilters.includes("branch")) setBranchAdvance([]);
    if (!selectedAdvanceFilters.includes("stream")) setStreamAdvance([]);
    if (!selectedAdvanceFilters.includes("final year")) setFinalYearAdvance([]);
    if (!selectedAdvanceFilters.includes("caste")) setCasteAdvance([]);
    if (!selectedAdvanceFilters.includes("pwd")) setPwdAdvance([]);
    if (!selectedAdvanceFilters.includes("ews")) setEwsAdvance([]);
  }, [selectedAdvanceFilters]);

  const [cohortSearch, setCohortSearch] = useState("");
  const [corporateSearch, setCorporateSearch] = useState("");
  const [domainSearch, setDomainSearch] = useState("");
  const [stateSearch, setStateSearch] = useState("");
  const [citySearch, setCitySearch] = useState("");
  const [instituteSearch, setInstituteSearch] = useState("");
  const [branchSearch, setBranchSearch] = useState("");
  const [streamSearch, setStreamSearch] = useState("");
  const [finalYearSearch, setFinalYearSearch] = useState("");

  const [finalYearOptions, setFinalYearOptions] = useState([]);
  const [cohortOptions, setCohortOptions] = useState([]);
  const [corporateOptions, setCorporateOptions] = useState([]);
  const [domainOptions, setDomainOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [instituteOptions, setInstituteOptions] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [programOptions, setProgramOptions] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const response = await api.get("admin/get_filter_dropdown");
        if (response.data) {
          setCohortOptions(response.data.cohorts || []);
          setCorporateOptions(response.data.corporates || []);
          setDomainOptions(response.data.domains || []);
          setStateOptions(response.data.states || []);
          setInstituteOptions(response.data.institutes || []);
          setBranchOptions(response.data.branches || []);
          setProgramOptions(response.data.programs || []);
          setFinalYearOptions(response.data.final_year || []);
        }
      } catch (error) {
        console.error("Error fetching dynamic dropdown options:", error);
      }
    };
    fetchDropdowns();
  }, []);

  const cohortsList = React.useMemo(() => cohortOptions.map(c => ({
    value: c.cohort_name,
    label: c.cohort_name,
    is_active: c.is_active,
    is_open: c.is_open
  })), [cohortOptions]);

  useEffect(() => {
    if (!cohortFilter && cohortOptions.length > 0) {
      const sortedCohorts = [...cohortOptions].sort((a, b) => Number(b.cohort_id) - Number(a.cohort_id));
      if (sortedCohorts.length > 0) {
        setCohortFilter(sortedCohorts[0].cohort_name);
      }
    }
  }, [cohortFilter, cohortOptions]);

  const cohortsListFiltered = React.useMemo(() => cohortsList.filter(opt =>
    opt.label.toLowerCase().includes(cohortSearch.toLowerCase())
  ), [cohortsList, cohortSearch]);

  const corporatesList = React.useMemo(() => corporateOptions.map(c => ({
    value: c.academy_id.toString(),
    label: c.academy_name
  })), [corporateOptions]);

  const corporatesListFiltered = React.useMemo(() => corporatesList.filter(opt =>
    opt.label.toLowerCase().includes(corporateSearch.toLowerCase())
  ), [corporatesList, corporateSearch]);

  const domainsList = React.useMemo(() => domainOptions.map(d => ({
    value: d.domain_id.toString(),
    label: d.domain_name,
    academy_id: d.academy_id?.toString()
  })), [domainOptions]);

  const domainsListForCorporate = React.useMemo(() => (corporateFilter.includes("all") || corporateFilter.length === 0)
    ? domainsList
    : domainsList.filter(dom => corporateFilter.includes(dom.academy_id)), [domainsList, corporateFilter]);

  const domainsListFiltered = React.useMemo(() => domainsListForCorporate.filter(opt =>
    opt.label.toLowerCase().includes(domainSearch.toLowerCase())
  ), [domainsListForCorporate, domainSearch]);

  const statesList = React.useMemo(() => stateOptions.map(s => ({
    value: s.state_id.toString(),
    label: s.state_name
  })), [stateOptions]);

  const statesListFiltered = React.useMemo(() => statesList.filter(opt =>
    opt.label.toLowerCase().includes(stateSearch.toLowerCase())
  ), [statesList, stateSearch]);

  // City list derived from institute options
  const citiesList = React.useMemo(() => {
    const uniqueCities = new Set();
    const list = [];
    instituteOptions.forEach(i => {
      const city = i.city_name || i.city;
      if (city && !uniqueCities.has(city.toLowerCase())) {
        uniqueCities.add(city.toLowerCase());
        list.push({
          value: city,
          label: city,
          state_id: i.state_id?.toString()
        });
      }
    });
    return list;
  }, [instituteOptions]);

  const citiesListForState = React.useMemo(() => (stateAdvance.length === 0)
    ? citiesList
    : citiesList.filter(c => {
      if (!c.state_id) return true;
      return stateAdvance.includes(c.state_id);
    }), [citiesList, stateAdvance]);

  const citiesListFiltered = React.useMemo(() => citiesListForState.filter(opt =>
    opt.label.toLowerCase().includes(citySearch.toLowerCase())
  ), [citiesListForState, citySearch]);

  const institutesList = React.useMemo(() => instituteOptions.map(i => ({
    value: i.institute_id.toString(),
    label: i.institute_name,
    state_id: i.state_id?.toString()
  })), [instituteOptions]);

  const institutesListForState = React.useMemo(() => {
    let list = institutesList;
    if (stateAdvance.length > 0) {
      list = list.filter(inst => inst.state_id && stateAdvance.includes(inst.state_id));
    }
    if (cityAdvance.length > 0) {
      list = list.filter(inst => {
        const instOpt = instituteOptions.find(io => io.institute_id.toString() === inst.value);
        const city = instOpt ? (instOpt.city_name || instOpt.city) : null;
        return city && cityAdvance.includes(city);
      });
    }
    return list;
  }, [institutesList, stateAdvance, cityAdvance, instituteOptions]);

  const institutesListFiltered = React.useMemo(() => institutesListForState.filter(opt =>
    opt.label.toLowerCase().includes(instituteSearch.toLowerCase())
  ), [institutesListForState, instituteSearch]);

  const branchesList = React.useMemo(() => branchOptions.map(b => ({
    value: b.branch_id.toString(),
    label: b.branch_name,
    program_id: b.program_id?.toString()
  })), [branchOptions]);

  const branchesListForProgram = React.useMemo(() => (streamAdvance.length === 0)
    ? branchesList
    : branchesList.filter(br => {
      if (!br.program_id) return true;
      return streamAdvance.includes(br.program_id);
    }), [branchesList, streamAdvance]);

  const branchesListFiltered = React.useMemo(() => branchesListForProgram.filter(opt =>
    opt.label.toLowerCase().includes(branchSearch.toLowerCase())
  ), [branchesListForProgram, branchSearch]);

  const streamsList = React.useMemo(() => programOptions.map(p => ({
    value: p.program_id.toString(),
    label: p.program_name
  })), [programOptions]);

  const streamsListFiltered = React.useMemo(() => streamsList.filter(opt =>
    opt.label.toLowerCase().includes(streamSearch.toLowerCase())
  ), [streamsList, streamSearch]);
  
  const finalYearList = React.useMemo(() => finalYearOptions.map((y) => ({
    value: y.year_id?.toString() || y.toString(),
    label: y.year_name || y.toString(),
  })), [finalYearOptions]);

  const finalYearListFiltered = React.useMemo(() => finalYearList.filter((opt) =>
    opt.label.toLowerCase().includes(finalYearSearch.toLowerCase())
  ), [finalYearList, finalYearSearch]);

  // Clear stale cities if states are selected
  useEffect(() => {
    if (stateAdvance.length > 0) {
      setCityAdvance((prev) =>
        prev.filter((city) => {
          const cityObj = citiesList.find(
            (c) => c.value?.trim().toLowerCase() === city?.trim().toLowerCase()
          );
          return cityObj && stateAdvance.includes(cityObj.state_id);
        })
      );
    }
  }, [stateAdvance, citiesList]);

  // Clear stale institutes if states or cities are selected
  useEffect(() => {
    setInstituteAdvance((prev) =>
      prev.filter((instId) => {
        const instObj = instituteOptions.find(
          (i) => i.institute_id?.toString() === instId
        );
        if (!instObj) return false;

        // Verify state match if states are selected
        if (stateAdvance.length > 0) {
          if (!instObj.state_id || !stateAdvance.includes(instObj.state_id.toString())) {
            return false;
          }
        }

        // Verify city match if cities are selected
        if (cityAdvance.length > 0) {
          const instCity = instObj.city_name || instObj.city;
          if (
            !instCity ||
            !cityAdvance.some((c) => c?.trim().toLowerCase() === instCity?.trim().toLowerCase())
          ) {
            return false;
          }
        }

        return true;
      })
    );
  }, [stateAdvance, cityAdvance, instituteOptions]);

  // Dynamically update domainFilter based on corporateFilter using the academy_id relationship
  useEffect(() => {
    if (corporateFilter.length === 0) {
      setDomainFilter([]);
    } else {
      const matchingDomainIds = domainsList
        .filter(dom => dom.academy_id && corporateFilter.includes(dom.academy_id))
        .map(dom => dom.value);
      setDomainFilter(matchingDomainIds);
    }
  }, [corporateFilter, domainsList]);


  const handleCorporateChange = (event) => {
    const {
      target: { value },
    } = event;

    if (value.includes("select-all")) {
      const allVals = corporatesListFiltered.map(opt => opt.value);
      const isAllSelected = allVals.every(val => corporateFilter.includes(val));
      if (isAllSelected) {
        setCorporateFilter(prev => prev.filter(val => !allVals.includes(val)));
      } else {
        setCorporateFilter(prev => [...new Set([...prev, ...allVals])]);
      }
    } else {
      setCorporateFilter(typeof value === "string" ? value.split(",") : value);
    }
  };

  const handleDomainChange = (event) => {
    const {
      target: { value },
    } = event;

    if (value.includes("select-all")) {
      const allVals = domainsListFiltered.map(opt => opt.value);
      const isAllSelected = allVals.every(val => domainFilter.includes(val));
      if (isAllSelected) {
        setDomainFilter(prev => prev.filter(val => !allVals.includes(val)));
      } else {
        setDomainFilter(prev => [...new Set([...prev, ...allVals])]);
      }
    } else {
      setDomainFilter(typeof value === "string" ? value.split(",") : value);
    }
  };

  // Dynamically compile active filters so that only selected sections go to the backend
  const getActiveFilterPayload = () => {
    const payload = {};

    if (cohortFilter) {
      payload.cohorts = [cohortFilter];
    }

    const filteredDomains = domainFilter.filter(d => d !== "select-all" && d !== "all");
    if (filteredDomains.length > 0) {
      payload.domains = filteredDomains;
    }

    const filteredStates = stateAdvance.filter(s => s !== "select-all");
    if (filteredStates.length > 0) {
      payload.states = filteredStates;
    }

    const filteredInstitutes = instituteAdvance.filter(i => i !== "select-all");
    if (filteredInstitutes.length > 0) {
      payload.institutes = filteredInstitutes;
    }

    const filteredBranches = branchAdvance.filter(b => b !== "select-all");
    if (filteredBranches.length > 0) {
      payload.branches = filteredBranches;
    }

    const filteredStreams = streamAdvance.filter(s => s !== "select-all");
    if (filteredStreams.length > 0) {
      payload.streams = filteredStreams;
    }

    const filteredFinalYears = finalYearAdvance.filter(y => y !== "select-all");
    if (filteredFinalYears.length > 0) {
      payload.final_years = filteredFinalYears;
    }

    if (casteAdvance.length > 0) {
      payload.castes = casteAdvance;
    }

    if (pwdAdvance.length > 0) {
      payload.pwds = pwdAdvance;
    }

    if (ewsAdvance.length > 0) {
      payload.ewss = ewsAdvance;
    }

    if (completionAdvance) {
      payload.completion = completionAdvance === "completed" ? "1" : "0";
    }

    return payload;
  };

  // Live log to console whenever filters change, demonstrating that ONLY selected sections are included
  useEffect(() => {
    const activePayload = getActiveFilterPayload();
    console.log("Current active payload to backend (only chosen filters):", activePayload);
  }, [
    cohortFilter,
    corporateFilter,
    domainFilter,
    stateAdvance,
    instituteAdvance,
    branchAdvance,
    streamAdvance,
    finalYearAdvance,
    casteAdvance,
    pwdAdvance,
    ewsAdvance,
    completionAdvance,
  ]);

  const fetchTableData = async (pageNumber = 1, size = pageSize) => {
    // 1. Get cohort ID
    const selectedCohortObj = cohortOptions.find(c => c.cohort_name === cohortFilter);
    const cohortId = selectedCohortObj ? selectedCohortObj.cohort_id : null;

    if (!cohortId) {
      alert("Please select a valid Cohort.");
      return;
    }

    // 2. Get domain IDs
    const domainIds = domainFilter
      .filter(d => d !== "select-all" && d !== "all")
      .map(d => parseInt(d, 10));

    if (domainIds.length === 0) {
      alert("Please select at least one Domain.");
      return;
    }

    // Filter institute IDs dynamically if a city is chosen
    let finalInstituteIds = instituteAdvance
      .filter(id => id !== "select-all")
      .map(id => parseInt(id, 10));

    if (cityAdvance.length > 0 && finalInstituteIds.length === 0) {
      finalInstituteIds = instituteOptions
        .filter(i => {
          const city = i.city_name || i.city;
          return city && cityAdvance.includes(city);
        })
        .map(i => i.institute_id);
    }

    setTableLoading(true);
    try {
      const payload = {
        cohort_id: cohortId,
        domain_ids: domainIds,
        page: pageNumber,
        page_size: size,
        branch: branchAdvance.filter(b => b !== "select-all").length > 0 ? branchAdvance.filter(b => b !== "select-all") : null,
        program_ids: streamAdvance.filter(id => id !== "select-all").length > 0 ? streamAdvance.filter(id => id !== "select-all").map(id => parseInt(id, 10)) : null,
        institute_ids: finalInstituteIds.length > 0 ? finalInstituteIds : null,
        state_ids: stateAdvance.filter(id => id !== "select-all").length > 0 ? stateAdvance.filter(id => id !== "select-all").map(id => parseInt(id, 10)) : null,
        final_year: finalYearAdvance.filter(y => y !== "select-all").length > 0 ? finalYearAdvance.filter(y => y !== "select-all") : null,
        course_access: courseAccessAdvance === "given" ? "1" : courseAccessAdvance === "not_given" ? "0" : null,
        completion: completionAdvance === "completed" ? "1" : completionAdvance === "not_completed" ? "0" : null,
        family_income: ewsAdvance.filter(inc => inc !== "select-all").length > 0 ? ewsAdvance.filter(inc => inc !== "select-all") : null,
        is_pwd: pwdAdvance.filter(p => p !== "select-all").length > 0 ? pwdAdvance.filter(p => p !== "select-all") : null,
        caste: casteAdvance.filter(c => c !== "select-all").length > 0 ? casteAdvance.filter(c => c !== "select-all") : null,
      };

      const response = await api.post("/admin/internship-students-report", payload);
      if (response.data) {
        const mappedData = (response.data.data || []).map((row) => ({
          internship_id: row.internship_id || row.user_id,
          name: `${row.first_name || ""} ${row.middle_name || ""} ${row.last_name || ""}`.trim().replace(/\s+/g, ' '),
          email: row.email,
          gender: row.gender,
          cohort: row.cohort_name,
          domain: row.domain_name,
          branch: row.branch,
          program: row.program_name,
          institute: row.institute_name,
          state: row.state_name,
          city: row.city_name || row.city,
          year_of_passing: row.year_of_passing,
          family_income: row.family_income,
          is_pwd: row.is_pwd,
          caste: row.caste,
          is_active: row.is_active,
          is_completed: row.completion,
          is_status: row.is_status,
          started_at: row.started_at,
          completed_at: row.completed_at,
          access_given: row.access_given,
        }));
        setTableData(mappedData);
        setTotalCount(response.data.total_count || 0);
        setShowTable(true);
      }
    } catch (error) {
      console.error("Error fetching report data:", error);
      alert("Failed to fetch report data. Please try again.");
    } finally {
      setTableLoading(false);
    }
  };

  const handlePageChange = (event, newPage) => {
    setTablePage(newPage);
    fetchTableData(newPage + 1, pageSize);
  };

  const handleRowsPerPageChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setTablePage(0);
    fetchTableData(1, newSize);
  };

  const handleApplyTable = () => {
    setTablePage(0);
    fetchTableData(1, pageSize);
  };

  const handleClearAllFilters = () => {
    // 1. Reset advanced states
    setStateAdvance([]);
    setCityAdvance([]);
    setInstituteAdvance([]);
    setBranchAdvance([]);
    setStreamAdvance([]);
    setFinalYearAdvance([]);
    setCasteAdvance([]);
    setPwdAdvance([]);
    setEwsAdvance([]);
    setCourseAccessAdvance("");
    setCompletionAdvance("");
    setSelectedAdvanceFilters([]);

    // 2. Reset dropdown search queries
    setCohortSearch("");
    setCorporateSearch("");
    setDomainSearch("");
    setStateSearch("");
    setCitySearch("");
    setInstituteSearch("");
    setBranchSearch("");
    setStreamSearch("");
    setFinalYearSearch("");
    setAdvanceFilterSearch("");

    // 3. Clear table and hide results
    setTableSearch("");
    setTablePage(0);
    setTableData([]);
    setTotalCount(0);
    setShowTable(false);
  };

  const handleDownloadCSV = async () => {
    const selectedCohortObj = cohortOptions.find(c => c.cohort_name === cohortFilter);
    const cohortId = selectedCohortObj ? selectedCohortObj.cohort_id : null;

    if (!cohortId) {
      alert("Please select a valid Cohort.");
      return;
    }

    const domainIds = domainFilter
      .filter(d => d !== "select-all" && d !== "all")
      .map(d => parseInt(d, 10));

    if (domainIds.length === 0) {
      alert("Please select at least one Domain.");
      return;
    }

    // Filter institute IDs dynamically if a city is chosen
    let finalInstituteIds = instituteAdvance
      .filter(id => id !== "select-all")
      .map(id => parseInt(id, 10));

    if (cityAdvance.length > 0 && finalInstituteIds.length === 0) {
      finalInstituteIds = instituteOptions
        .filter(i => {
          const city = i.city_name || i.city;
          return city && cityAdvance.includes(city);
        })
        .map(i => i.institute_id);
    }

    setExportLoading(true);
    try {
      const payload = {
        cohort_id: cohortId,
        domain_ids: domainIds,
        branch: branchAdvance.filter(b => b !== "select-all").length > 0 ? branchAdvance.filter(b => b !== "select-all") : null,
        program_ids: streamAdvance.filter(id => id !== "select-all").length > 0 ? streamAdvance.filter(id => id !== "select-all").map(id => parseInt(id, 10)) : null,
        institute_ids: finalInstituteIds.length > 0 ? finalInstituteIds : null,
        state_ids: stateAdvance.filter(id => id !== "select-all").length > 0 ? stateAdvance.filter(id => id !== "select-all").map(id => parseInt(id, 10)) : null,
        final_year: finalYearAdvance.filter(y => y !== "select-all").length > 0 ? finalYearAdvance.filter(y => y !== "select-all") : null,
        course_access: courseAccessAdvance === "given" ? "1" : courseAccessAdvance === "not_given" ? "0" : null,
        completion: completionAdvance === "completed" ? "1" : completionAdvance === "not_completed" ? "0" : null,
        family_income: ewsAdvance.filter(inc => inc !== "select-all").length > 0 ? ewsAdvance.filter(inc => inc !== "select-all") : null,
        is_pwd: pwdAdvance.filter(p => p !== "select-all").length > 0 ? pwdAdvance.filter(p => p !== "select-all") : null,
        caste: casteAdvance.filter(c => c !== "select-all").length > 0 ? casteAdvance.filter(c => c !== "select-all") : null,
      };

      const response = await api.post("admin/internship-students-report/download", payload, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `internship_students_cohort${cohortId}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading CSV report:", error);
      alert("Failed to download CSV report.");
    } finally {
      setExportLoading(false);
    }
  };


  //Table search
  const filteredTableData = tableData.filter((row) => {
    console.log("DEBUG [filteredTableData] - Row:", row);
    console.log("DEBUG [filteredTableData] - tableSearch:", tableSearch);
    console.log("DEBUG [filteredTableData] - courseAccessAdvance:", courseAccessAdvance);
    console.log("DEBUG [filteredTableData] - completionAdvance:", completionAdvance);

    const matchesSearch = Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(tableSearch.toLowerCase());

    console.log("DEBUG [filteredTableData] - matchesSearch evaluation:", matchesSearch);
    if (!matchesSearch) return false;

    // Course Access filter
    if (courseAccessAdvance === "given") {
      const isGiven = String(row.access_given) === "1" || String(row.access_given).toLowerCase() === "yes" || row.access_given === true;
      console.log("DEBUG [filteredTableData] - Course Access 'given', isGiven:", isGiven);
      if (!isGiven) return false;
    } else if (courseAccessAdvance === "not_given") {
      const isGiven = String(row.access_given) === "1" || String(row.access_given).toLowerCase() === "yes" || row.access_given === true;
      console.log("DEBUG [filteredTableData] - Course Access 'not_given', isGiven:", isGiven);
      if (isGiven) return false;
    }

    // Completion filter
    if (completionAdvance === "completed") {
      const isCompleted = String(row.is_completed) === "1" || row.is_completed === 1 || String(row.is_completed).toLowerCase() === "yes" || row.is_completed === true || String(row.is_completed).toLowerCase() === "completed";
      console.log("DEBUG [filteredTableData] - Completion 'completed', isCompleted:", isCompleted);
      if (!isCompleted) return false;
    } else if (completionAdvance === "not_completed") {
      const isCompleted = String(row.is_completed) === "1" || row.is_completed === 1 || String(row.is_completed).toLowerCase() === "yes" || row.is_completed === true || String(row.is_completed).toLowerCase() === "completed";
      console.log("DEBUG [filteredTableData] - Completion 'not_completed', isCompleted:", isCompleted);
      if (isCompleted) return false;
    }

    console.log("DEBUG [filteredTableData] - Row passed all filters!");
    return true;
  });

  // Table pagination (server-side handled)
  const paginatedTableData = filteredTableData;

  return (
    <Fade in={true} timeout={600}>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        {/* Banner Header */}
        <ReportHeader>
          <Grid container alignItems="center" spacing={4}>
            <Grid item xs={12}>
              <Chip
                label="Student Analytics Portal"
                size="small"
                sx={{
                  backgroundColor: "rgba(255,255,255,0.15)",
                  color: "#fff",
                  fontWeight: 600,
                  mb: 2,
                  backdropFilter: "blur(10px)",
                }}
              />
              <Typography variant="h3" fontWeight={800} gutterBottom sx={{ letterSpacing: "-1px" }}>
                Student Reports & Analytics
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.8, maxWidth: "600px" }}>
                Generate customized reports and export spreadsheets.
              </Typography>
            </Grid>
          </Grid>
        </ReportHeader>

        {/* Interactive Report Generator with all 10 filters inside one single card */}
        <PremiumCard sx={{ p: 4, mb: 4 }}>
          <Grid container spacing={1.5}>
            {/* --- Section 1: Core Parameters --- */}
            {/* 1. Cohort Dropdown with Radio buttons */}
            <Grid item xs={12} sm={4} md={1.8}>
              <FormControl fullWidth required size="small">
                <InputLabel id="cohort-select-label" sx={{ "& .MuiFormLabel-asterisk": { color: "red" } }}>Cohort</InputLabel>
                <Select
                  labelId="cohort-select-label"
                  value={cohortFilter}
                  label="Cohort"
                  onChange={(e) => setCohortFilter(e.target.value)}
                  sx={{ borderRadius: "10px" }}
                  onClose={() => setCohortSearch("")}
                  MenuProps={{ autoFocus: false }}
                  renderValue={(selected) => {
                    if (!selected) return "Select Cohort";
                    const found = cohortsList.find(c => c.value === selected);
                    return found ? found.label : `Cohort ${selected}`;
                  }}
                >
                  <Box sx={{ p: 1, position: "sticky", top: 0, bgcolor: "background.paper", zIndex: 1 }}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Search Cohort..."
                      value={cohortSearch}
                      onChange={(e) => setCohortSearch(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon size="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  {cohortsListFiltered.filter(opt => opt.value !== "all").map((opt) => (
                    <MenuItem key={opt.value} value={opt.value} sx={{ display: "flex", gap: 1 }}>
                      <Radio checked={cohortFilter === opt.value} size="small" color="primary" />
                      <span>{opt.label}</span>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* 2. Corporate Dropdown with Multi-select Checkboxes */}
            <Grid item xs={12} sm={4} md={2.0}>
              <FormControl fullWidth required size="small">
                <InputLabel id="corporate-select-label" sx={{ "& .MuiFormLabel-asterisk": { color: "red" } }}>Corporate</InputLabel>
                <Select
                  labelId="corporate-select-label"
                  multiple
                  value={corporateFilter}
                  label="Corporate"
                  onChange={handleCorporateChange}
                  sx={{ borderRadius: "10px" }}
                  onClose={() => setCorporateSearch("")}
                  MenuProps={{ autoFocus: false }}
                  renderValue={(selected) => {
                    if (selected.length === 0) return "Select Corporate";
                    return selected.map((val) => {
                      const found = corporatesList.find(c => c.value === val);
                      return found ? found.label.toUpperCase() : val.toUpperCase();
                    }).join(", ");
                  }}
                >
                  <Box sx={{ p: 1, position: "sticky", top: 0, bgcolor: "background.paper", zIndex: 1 }}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Search Corporate..."
                      value={corporateSearch}
                      onChange={(e) => setCorporateSearch(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon size="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <MenuItem value="select-all" sx={{ display: "flex", gap: 1, fontWeight: "bold" }}>
                    <Checkbox
                      checked={corporatesListFiltered.length > 0 && corporatesListFiltered.map(opt => opt.value).every(val => corporateFilter.includes(val))}
                      size="small"
                      sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }}
                    />
                    <span>Select All</span>
                  </MenuItem>
                  {corporatesListFiltered.filter(opt => opt.value !== "all").map((opt) => (
                    <MenuItem key={opt.value} value={opt.value} sx={{ display: "flex", gap: 1 }}>
                      <Checkbox checked={corporateFilter.includes(opt.value)} size="small" sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }} />
                      <span>{opt.label}</span>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* 3. Domain Dropdown with Multi-select Checkboxes */}
            <Grid item xs={12} sm={4} md={2.0}>
              <FormControl fullWidth size="small">
                <InputLabel id="domain-select-label">Domain</InputLabel>
                <Select
                  labelId="domain-select-label"
                  multiple
                  value={domainFilter}
                  label="Domain"
                  onChange={handleDomainChange}
                  sx={{ borderRadius: "10px" }}
                  onClose={() => setDomainSearch("")}
                  MenuProps={{ autoFocus: false }}
                  renderValue={(selected) => {
                    if (selected.length === 0) return "Select Domain";
                    return selected.map((val) => {
                      const found = domainsList.find(d => d.value === val);
                      return found ? found.label : val;
                    }).join(", ");
                  }}
                >
                  <Box sx={{ p: 1, position: "sticky", top: 0, bgcolor: "background.paper", zIndex: 1 }}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Search Domain..."
                      value={domainSearch}
                      onChange={(e) => setDomainSearch(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon size="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <MenuItem value="select-all" sx={{ display: "flex", gap: 1, fontWeight: "bold" }}>
                    <Checkbox
                      checked={domainsListFiltered.length > 0 && domainsListFiltered.map(opt => opt.value).every(val => domainFilter.includes(val))}
                      size="small"
                      sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }}
                    />
                    <span>Select All</span>
                  </MenuItem>
                  {domainsListFiltered.filter(opt => opt.value !== "all").map((opt) => (
                    <MenuItem key={opt.value} value={opt.value} sx={{ display: "flex", gap: 1 }}>
                      <Checkbox checked={domainFilter.includes(opt.value)} size="small" sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }} />
                      <span>{opt.label}</span>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* 3b. Apply Button */}
            <Grid item xs={12} sm={4} md={1.5}>
              <Button
                variant="contained"
                onClick={handleApplyTable}
                disabled={tableLoading}
                fullWidth
                sx={{
                  background: "linear-gradient(135deg, #052467ff 0%, #1d4ed8 100%)",
                  color: "#ffffff",
                  borderRadius: "10px",
                  height: "38px",
                  textTransform: "none",
                  fontWeight: 700,
                  boxShadow: "0 4px 12px rgba(29, 78, 216, 0.15)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #1d4ed8 0%, #052467ff 100%)",
                  },
                }}
              >
                {tableLoading ? <CircularProgress size={16} color="inherit" /> : "Apply"}
              </Button>
            </Grid>

            {/* 3c. Master Advance Filter dropdown kept OUTSIDE */}
            <Grid item xs={12} sm={4} md={2.0}>
              <FormControl fullWidth size="small">
                <Select
                  multiple
                  displayEmpty
                  value={selectedAdvanceFilters}
                  onChange={handleAdvanceFilterToggleChange}
                  onClose={() => setAdvanceFilterSearch("")}
                  MenuProps={{ autoFocus: false }}
                  IconComponent={() => null} // Keep clean button style select
                  renderValue={() => (
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", color: "#ffffff", fontWeight: 700, width: "100%" }}>
                      <FilterIcon sx={{ fontSize: "1.1rem" }} />
                      <span>Advance Filter</span>
                    </Box>
                  )}
                  sx={{
                    background: "linear-gradient(135deg, #052467ff 0%, #1d4ed8 100%)",
                    color: "#ffffff",
                    borderRadius: "10px",
                    height: "38px",
                    display: "flex",
                    alignItems: "center",
                    boxShadow: "0 4px 12px rgba(29, 78, 216, 0.15)",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "& .MuiSelect-select": {
                      padding: "0 14px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "38px",
                      paddingRight: "14px !important",
                    },
                    "&:hover": {
                      background: "linear-gradient(135deg, #1d4ed8 0%, #052467ff 100%)",
                    },
                  }}
                >
                  <Box sx={{ p: 1, position: "sticky", top: 0, bgcolor: "background.paper", zIndex: 1 }}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Search Filter..."
                      value={advanceFilterSearch}
                      onChange={(e) => setAdvanceFilterSearch(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon size="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <MenuItem value="select-all" sx={{ display: "flex", gap: 1, fontWeight: "bold" }}>
                    <Checkbox
                      checked={advanceFilterOptionsFiltered.length > 0 && advanceFilterOptionsFiltered.every(opt => selectedAdvanceFilters.includes(opt.value))}
                      size="small"
                      sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }}
                    />
                    <span>Select All</span>
                  </MenuItem>
                  {advanceFilterOptionsFiltered.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value} sx={{ display: "flex", gap: 1 }}>
                      <Checkbox checked={selectedAdvanceFilters.includes(opt.value)} size="small" sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }} />
                      <span>{opt.label}</span>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Clear Filter Button */}
            <Grid item xs={12} sm={4} md={1.5}>
              <Button
                variant="outlined"
                onClick={handleClearAllFilters}
                startIcon={<FilterIcon sx={{ fontSize: "1.05rem !important" }} />}
                fullWidth
                sx={{
                  color: "#ea2121ff",
                  borderColor: "#d51e1eff",
                  borderRadius: "10px",
                  height: "38px",
                  textTransform: "none",
                  fontWeight: 700,
                  "&:hover": {
                    borderColor: "#b91c1c",
                    backgroundColor: "rgba(220, 38, 38, 0.04)",
                  },
                }}
              >
                Clear
              </Button>
            </Grid>

            {selectedAdvanceFilters.length > 0 && (
              <>
                <Grid item xs={12} sx={{ mt: 1 }}>
                  <Divider sx={{ mb: 2 }} />
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "12px" }}>

                    {/* Course Access Dropdown */}
                    {selectedAdvanceFilters.includes("course access") && (
                      <FormControl size="small" sx={{ width: "160px" }}>
                        <InputLabel id="advance-course-access-label">Course Access</InputLabel>
                        <Select
                          labelId="advance-course-access-label"
                          value={courseAccessAdvance}
                          label="Course Access"
                          onChange={(e) => setCourseAccessAdvance(e.target.value)}
                          sx={{ borderRadius: "10px" }}
                        >
                          <MenuItem value="">Select Status</MenuItem>
                          <MenuItem value="given">Given</MenuItem>
                          <MenuItem value="not_given">Not-Given</MenuItem>
                        </Select>
                      </FormControl>
                    )}

                    {/* Completion Dropdown */}
                    {selectedAdvanceFilters.includes("completion") && (
                      <FormControl size="small" sx={{ width: "160px" }}>
                        <InputLabel id="advance-completion-label">Completion</InputLabel>
                        <Select
                          labelId="advance-completion-label"
                          value={completionAdvance}
                          label="Completion"
                          onChange={(e) => setCompletionAdvance(e.target.value)}
                          sx={{ borderRadius: "10px" }}
                        >
                          <MenuItem value="">Select Status</MenuItem>
                          <MenuItem value="completed">Completed</MenuItem>
                          <MenuItem value="not_completed">Not-Completed</MenuItem>
                        </Select>
                      </FormControl>
                    )}

                    {/* 4. State Dropdown */}
                    {selectedAdvanceFilters.includes("state") && (
                      <FormControl size="small" sx={{ width: "160px" }}>
                        <InputLabel id="advance-state-label">State</InputLabel>
                        <Select
                          labelId="advance-state-label"
                          multiple
                          value={stateAdvance}
                          label="State"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.includes("select-all")) {
                              const allVals = statesListFiltered.map(opt => opt.value);
                              const isAllSelected = allVals.every(val => stateAdvance.includes(val));
                              if (isAllSelected) {
                                setStateAdvance(prev => prev.filter(val => !allVals.includes(val)));
                              } else {
                                setStateAdvance(prev => [...new Set([...prev, ...allVals])]);
                              }
                            } else {
                              setStateAdvance(value);
                            }
                          }}
                          sx={{ borderRadius: "10px" }}
                          onClose={() => setStateSearch("")}
                          MenuProps={{ autoFocus: false }}
                          renderValue={(selected) => {
                            if (selected.length === 0) return "Select State";
                            return selected.map(val => {
                              const found = statesList.find(s => s.value === val);
                              return found ? found.label : val;
                            }).join(", ");
                          }}
                        >
                          <Box sx={{ p: 1, position: "sticky", top: 0, bgcolor: "background.paper", zIndex: 1 }}>
                            <TextField
                              size="small"
                              fullWidth
                              placeholder="Search State..."
                              value={stateSearch}
                              onChange={(e) => setStateSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                  e.stopPropagation();
                                }
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchIcon size="small" />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Box>
                          <MenuItem value="select-all" sx={{ display: "flex", gap: 1, fontWeight: "bold" }}>
                            <Checkbox
                              checked={statesListFiltered.length > 0 && statesListFiltered.map(opt => opt.value).every(val => stateAdvance.includes(val))}
                              size="small"
                              sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }}
                            />
                            <span>Select All</span>
                          </MenuItem>
                          {statesListFiltered.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value} sx={{ display: "flex", gap: 1 }}>
                              <Checkbox checked={stateAdvance.indexOf(opt.value) > -1} size="small" sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }} />
                              <span>{opt.label}</span>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                    {/* City Dropdown */}
                    {selectedAdvanceFilters.includes("city") && (
                      <FormControl size="small" sx={{ width: "160px" }}>
                        <InputLabel id="advance-city-label">City</InputLabel>
                        <Select
                          labelId="advance-city-label"
                          multiple
                          value={cityAdvance}
                          label="City"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.includes("select-all")) {
                              const allVals = citiesListFiltered.map(opt => opt.value);
                              const isAllSelected = allVals.every(val => cityAdvance.includes(val));
                              if (isAllSelected) {
                                setCityAdvance(prev => prev.filter(val => !allVals.includes(val)));
                              } else {
                                setCityAdvance(prev => [...new Set([...prev, ...allVals])]);
                              }
                            } else {
                              setCityAdvance(value);
                            }
                          }}
                          sx={{ borderRadius: "10px" }}
                          onClose={() => setCitySearch("")}
                          MenuProps={{ autoFocus: false }}
                          renderValue={(selected) => {
                            if (selected.length === 0) return "Select City";
                            return selected.join(", ");
                          }}
                        >
                          <Box sx={{ p: 1, position: "sticky", top: 0, bgcolor: "background.paper", zIndex: 1 }}>
                            <TextField
                              size="small"
                              fullWidth
                              placeholder="Search City..."
                              value={citySearch}
                              onChange={(e) => setCitySearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                  e.stopPropagation();
                                }
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchIcon size="small" />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Box>
                          <MenuItem value="select-all" sx={{ display: "flex", gap: 1, fontWeight: "bold" }}>
                            <Checkbox
                              checked={citiesListFiltered.length > 0 && citiesListFiltered.map(opt => opt.value).every(val => cityAdvance.includes(val))}
                              size="small"
                              sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }}
                            />
                            <span>Select All</span>
                          </MenuItem>
                          {citiesListFiltered.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value} sx={{ display: "flex", gap: 1 }}>
                              <Checkbox checked={cityAdvance.indexOf(opt.value) > -1} size="small" sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }} />
                              <span>{opt.label}</span>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                    {/* 5. Institute Dropdown */}
                    {selectedAdvanceFilters.includes("institute") && (
                      <FormControl size="small" sx={{ width: "180px" }}>
                        <InputLabel id="advance-institute-label">Institute</InputLabel>
                        <Select
                          labelId="advance-institute-label"
                          multiple
                          value={instituteAdvance}
                          label="Institute"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.includes("select-all")) {
                              const allVals = institutesListFiltered.map(opt => opt.value);
                              const isAllSelected = allVals.every(val => instituteAdvance.includes(val));
                              if (isAllSelected) {
                                setInstituteAdvance(prev => prev.filter(val => !allVals.includes(val)));
                              } else {
                                setInstituteAdvance(prev => [...new Set([...prev, ...allVals])]);
                              }
                            } else {
                              setInstituteAdvance(value);
                            }
                          }}
                          sx={{ borderRadius: "10px" }}
                          onClose={() => setInstituteSearch("")}
                          MenuProps={{ autoFocus: false }}
                          renderValue={(selected) => {
                            if (selected.length === 0) return "Select Institute";
                            return selected.map(val => {
                              const found = institutesList.find(i => i.value === val);
                              return found ? found.label : val;
                            }).join(", ");
                          }}
                        >
                          <Box sx={{ p: 1, position: "sticky", top: 0, bgcolor: "background.paper", zIndex: 1 }}>
                            <TextField
                              size="small"
                              fullWidth
                              placeholder="Search Institute..."
                              value={instituteSearch}
                              onChange={(e) => setInstituteSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                  e.stopPropagation();
                                }
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchIcon size="small" />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Box>
                          <MenuItem value="select-all" sx={{ display: "flex", gap: 1, fontWeight: "bold" }}>
                            <Checkbox
                              checked={institutesListFiltered.length > 0 && institutesListFiltered.map(opt => opt.value).every(val => instituteAdvance.includes(val))}
                              size="small"
                              sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }}
                            />
                            <span>Select All</span>
                          </MenuItem>
                          {institutesListFiltered.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value} sx={{ display: "flex", gap: 1 }}>
                              <Checkbox checked={instituteAdvance.indexOf(opt.value) > -1} size="small" sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }} />
                              <span>{opt.label}</span>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                    {/* 7. Stream Dropdown */}
                    {selectedAdvanceFilters.includes("stream") && (
                      <FormControl size="small" sx={{ width: "160px" }}>
                        <InputLabel id="advance-stream-label">Stream</InputLabel>
                        <Select
                          labelId="advance-stream-label"
                          multiple
                          value={streamAdvance}
                          label="Stream"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.includes("select-all")) {
                              const allVals = streamsListFiltered.map(opt => opt.value);
                              const isAllSelected = allVals.every(val => streamAdvance.includes(val));
                              if (isAllSelected) {
                                setStreamAdvance(prev => prev.filter(val => !allVals.includes(val)));
                              } else {
                                setStreamAdvance(prev => [...new Set([...prev, ...allVals])]);
                              }
                            } else {
                              setStreamAdvance(value);
                            }
                          }}
                          sx={{ borderRadius: "10px" }}
                          onClose={() => setStreamSearch("")}
                          MenuProps={{ autoFocus: false }}
                          renderValue={(selected) => {
                            if (selected.length === 0) return "Select Stream";
                            return selected.map(val => {
                              const found = streamsList.find(s => s.value === val);
                              return found ? found.label : val;
                            }).join(", ");
                          }}
                        >
                          <Box sx={{ p: 1, position: "sticky", top: 0, bgcolor: "background.paper", zIndex: 1 }}>
                            <TextField
                              size="small"
                              fullWidth
                              placeholder="Search Stream..."
                              value={streamSearch}
                              onChange={(e) => setStreamSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                  e.stopPropagation();
                                }
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchIcon size="small" />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Box>
                          <MenuItem value="select-all" sx={{ display: "flex", gap: 1, fontWeight: "bold" }}>
                            <Checkbox
                              checked={streamsListFiltered.length > 0 && streamsListFiltered.map(opt => opt.value).every(val => streamAdvance.includes(val))}
                              size="small"
                              sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }}
                            />
                            <span>Select All</span>
                          </MenuItem>
                          {streamsListFiltered.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value} sx={{ display: "flex", gap: 1 }}>
                              <Checkbox checked={streamAdvance.indexOf(opt.value) > -1} size="small" sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }} />
                              <span>{opt.label}</span>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                    {/* 6. Branch Dropdown */}
                    {selectedAdvanceFilters.includes("branch") && (
                      <FormControl size="small" sx={{ width: "160px" }}>
                        <InputLabel id="advance-branch-label">Branch</InputLabel>
                        <Select
                          labelId="advance-branch-label"
                          multiple
                          value={branchAdvance}
                          label="Branch"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.includes("select-all")) {
                              const allVals = branchesListFiltered.map(opt => opt.value);
                              const isAllSelected = allVals.every(val => branchAdvance.includes(val));
                              if (isAllSelected) {
                                setBranchAdvance(prev => prev.filter(val => !allVals.includes(val)));
                              } else {
                                setBranchAdvance(prev => [...new Set([...prev, ...allVals])]);
                              }
                            } else {
                              setBranchAdvance(value);
                            }
                          }}
                          sx={{ borderRadius: "10px" }}
                          onClose={() => setBranchSearch("")}
                          MenuProps={{ autoFocus: false }}
                          renderValue={(selected) => {
                            if (selected.length === 0) return "Select Branch";
                            return selected.map(val => {
                              const found = branchesList.find(b => b.value === val);
                              return found ? found.label : val;
                            }).join(", ");
                          }}
                        >
                          <Box sx={{ p: 1, position: "sticky", top: 0, bgcolor: "background.paper", zIndex: 1 }}>
                            <TextField
                              size="small"
                              fullWidth
                              placeholder="Search Branch..."
                              value={branchSearch}
                              onChange={(e) => setBranchSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                  e.stopPropagation();
                                }
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchIcon size="small" />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Box>
                          <MenuItem value="select-all" sx={{ display: "flex", gap: 1, fontWeight: "bold" }}>
                            <Checkbox
                              checked={branchesListFiltered.length > 0 && branchesListFiltered.map(opt => opt.value).every(val => branchAdvance.includes(val))}
                              size="small"
                              sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }}
                            />
                            <span>Select All</span>
                          </MenuItem>
                          {branchesListFiltered.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value} sx={{ display: "flex", gap: 1 }}>
                              <Checkbox checked={branchAdvance.indexOf(opt.value) > -1} size="small" sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }} />
                              <span>{opt.label}</span>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                    {/* Final Year Dropdown */}
                    {selectedAdvanceFilters.includes("final year") && (
                      <FormControl size="small" sx={{ width: "160px" }}>
                        <InputLabel id="advance-finalyear-label">Final Year</InputLabel>
                        <Select
                          labelId="advance-finalyear-label"
                          multiple
                          value={finalYearAdvance}
                          label="Final Year"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.includes("select-all")) {
                              const allVals = finalYearListFiltered.map(opt => opt.value);
                              const isAllSelected = allVals.every(val => finalYearAdvance.includes(val));
                              if (isAllSelected) {
                                setFinalYearAdvance(prev => prev.filter(val => !allVals.includes(val)));
                              } else {
                                setFinalYearAdvance(prev => [...new Set([...prev, ...allVals])]);
                              }
                            } else {
                              setFinalYearAdvance(value);
                            }
                          }}
                          sx={{ borderRadius: "10px" }}
                          onClose={() => setFinalYearSearch("")}
                          MenuProps={{ autoFocus: false }}
                          renderValue={(selected) => {
                            if (selected.length === 0) return "Select Final Year";
                            return selected.map(val => {
                              const found = finalYearList.find(y => y.value === val);
                              return found ? found.label : val;
                            }).join(", ");
                          }}
                        >
                          <Box sx={{ p: 1, position: "sticky", top: 0, bgcolor: "background.paper", zIndex: 1 }}>
                            <TextField
                              size="small"
                              fullWidth
                              placeholder="Search Final Year..."
                              value={finalYearSearch}
                              onChange={(e) => setFinalYearSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                  e.stopPropagation();
                                }
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchIcon size="small" />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Box>
                          <MenuItem value="select-all" sx={{ display: "flex", gap: 1, fontWeight: "bold" }}>
                            <Checkbox
                              checked={finalYearListFiltered.length > 0 && finalYearListFiltered.map(opt => opt.value).every(val => finalYearAdvance.includes(val))}
                              size="small"
                              sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }}
                            />
                            <span>Select All</span>
                          </MenuItem>
                          {finalYearListFiltered.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value} sx={{ display: "flex", gap: 1 }}>
                              <Checkbox checked={finalYearAdvance.indexOf(opt.value) > -1} size="small" sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }} />
                              <span>{opt.label}</span>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                    {/* 8. Caste Dropdown */}
                    {selectedAdvanceFilters.includes("caste") && (
                      <FormControl size="small" sx={{ width: "160px" }}>
                        <InputLabel id="advance-caste-label">Caste</InputLabel>
                        <Select
                          labelId="advance-caste-label"
                          multiple
                          value={casteAdvance}
                          label="Caste"
                          onChange={(e) => setCasteAdvance(e.target.value)}
                          sx={{ borderRadius: "10px" }}
                          renderValue={(selected) => {
                            if (selected.length === 0) return "Select Caste";
                            return selected.join(", ");
                          }}
                        >
                          {["General", "OBC", "SC", "ST"].map((name) => (
                            <MenuItem key={name} value={name} sx={{ display: "flex", gap: 1 }}>
                              <Checkbox checked={casteAdvance.indexOf(name) > -1} size="small" sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }} />
                              <span>{name}</span>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                    {/* 9. PWD Dropdown */}
                    {selectedAdvanceFilters.includes("pwd") && (
                      <FormControl size="small" sx={{ width: "160px" }}>
                        <InputLabel id="advance-pwd-label">PWD</InputLabel>
                        <Select
                          labelId="advance-pwd-label"
                          multiple
                          value={pwdAdvance}
                          label="PWD"
                          onChange={(e) => setPwdAdvance(e.target.value)}
                          sx={{ borderRadius: "10px" }}
                          renderValue={(selected) => {
                            if (selected.length === 0) return "Select PWD";
                            return selected.join(", ");
                          }}
                        >
                          {["Yes", "No", "0", "1"].map((name) => (
                            <MenuItem key={name} value={name} sx={{ display: "flex", gap: 1 }}>
                              <Checkbox checked={pwdAdvance.indexOf(name) > -1} size="small" sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }} />
                              <span>{name}</span>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                    {/* 10. EWS Dropdown */}
                    {selectedAdvanceFilters.includes("ews") && (
                      <FormControl size="small" sx={{ width: "160px" }}>
                        <InputLabel id="advance-ews-label">EWS</InputLabel>
                        <Select
                          labelId="advance-ews-label"
                          multiple
                          value={ewsAdvance}
                          label="EWS"
                          onChange={(e) => setEwsAdvance(e.target.value)}
                          sx={{ borderRadius: "10px" }}
                          renderValue={(selected) => {
                            if (selected.length === 0) return "Select EWS";
                            const ewsMapping = [
                              { value: "<200000", label: "< 2,00,000" },
                              { value: "<300000", label: "< 3,00,000" },
                              { value: "<400000", label: "< 4,00,000" },
                              { value: "<500000", label: "< 5,00,000" },
                              { value: "<600000", label: "< 6,00,000" },
                              { value: "<700000", label: "< 7,00,000" },
                              { value: "<800000", label: "< 8,00,000" },
                              { value: "<900000", label: "< 9,00,000" },
                              { value: "<1000000", label: "< 10,00,000" },
                              { value: ">1000000", label: "Above 10,00,000" },
                            ];
                            return selected.map(val => {
                              const found = ewsMapping.find(opt => opt.value === val);
                              return found ? found.label : val;
                            }).join(", ");
                          }}
                        >
                          {[
                            { value: "<200000", label: "< 2,00,000" },
                            { value: "<300000", label: "< 3,00,000" },
                            { value: "<400000", label: "< 4,00,000" },
                            { value: "<500000", label: "< 5,00,000" },
                            { value: "<600000", label: "< 6,00,000" },
                            { value: "<700000", label: "< 7,00,000" },
                            { value: "<800000", label: "< 8,00,000" },
                            { value: "<900000", label: "< 9,00,000" },
                            { value: "<1000000", label: "< 10,00,000" },
                            { value: ">1000000", label: "Above 10,00,000" },
                          ].map((opt) => (
                            <MenuItem key={opt.value} value={opt.value} sx={{ display: "flex", gap: 1 }}>
                              <Checkbox checked={ewsAdvance.indexOf(opt.value) > -1} size="small" sx={{ color: "#1d4ed8", '&.Mui-checked': { color: "#1d4ed8" } }} />
                              <span>{opt.label}</span>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                  </Box>
                </Grid>
              </>)}
          </Grid>
        </PremiumCard>
        {!showTable && (
          <PremiumCard
            sx={{
              p: 6,
              textAlign: "center",
              borderStyle: "dashed",
              borderWidth: "2px",
              borderColor: "rgba(29, 78, 216, 0.2)",
              backgroundColor: "rgba(29, 78, 216, 0.02)",
              borderRadius: "16px",
              backdropFilter: "blur(10px)",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                borderColor: "rgba(29, 78, 216, 0.4)",
                backgroundColor: "rgba(29, 78, 216, 0.04)",
              },
            }}
          >
            <FilterIcon sx={{ fontSize: "3rem", color: "rgba(29, 78, 216, 0.5)", mb: 2 }} />
            <Typography variant="h6" fontWeight={700} color="text.primary" gutterBottom>
              Ready to Generate Report
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: "480px", mx: "auto", mb: 3 }}>
              Select your Cohort and other desired filters above, then click the <strong>Apply</strong> button to load the dynamic student data report.
            </Typography>
          </PremiumCard>
        )}
        {showTable && (
          <PremiumCard sx={{ p: 3 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography 
                  variant="subtitle2" 
                  fontWeight={700} 
                  sx={{ 
                    backgroundColor: "rgba(5, 36, 103, 0.08)", 
                    color: "#052467ff", 
                    px: 2, 
                    py: 0.8, 
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    border: "1px solid rgba(5, 36, 103, 0.1)"
                  }}
                >
                  Total: <span style={{ color: "#1d4ed8" }}>{totalCount}</span>
                </Typography>
                <TextField
                  size="small"
                  placeholder="Search students..."
                  value={tableSearch}
                  onChange={(e) => setTableSearch(e.target.value)}
                  sx={{
                    width: "280px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              {/* Download Icon - conditionally visible if data is available */}
              {filteredTableData.length > 0 && (
                <Button
                  variant="contained"
                  disabled={exportLoading}
                  startIcon={exportLoading ? <CircularProgress size={16} color="inherit" /> : <DownloadIcon />}
                  onClick={handleDownloadCSV}
                  sx={{
                    background: "linear-gradient(135deg, #052467ff 0%, #1d4ed8 100%)",
                    color: "#ffffff",
                    borderRadius: "10px",
                    height: "38px",
                    px: 2.5,
                    textTransform: "none",
                    fontWeight: 700,
                    boxShadow: "0 4px 12px rgba(29, 78, 216, 0.15)",
                    "&:hover": {
                      background: "linear-gradient(135deg, #1d4ed8 0%, #052467ff 100%)",
                    },
                  }}
                >
                  {exportLoading ? "Downloading..." : "Download"}
                </Button>
              )}
            </Box>

            <TableContainer component={Paper} sx={{ maxHeight: 600, overflow: "auto", boxShadow: "none", border: "1px solid rgba(226, 232, 240, 0.8)", borderRadius: "12px" }}>
              <Table 
                stickyHeader 
                sx={{ 
                  minWidth: 1400,
                  "& th": {
                    backgroundColor: "#052467ff !important",
                    color: "#ffffff !important",
                    fontWeight: "700 !important",
                    borderBottom: "1px solid rgba(255, 255, 255, 0.1) !important"
                  }
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Gender</TableCell>
                    <TableCell>Domain</TableCell>
                    <TableCell>State</TableCell>
                    <TableCell>City</TableCell>
                    <TableCell>Institute</TableCell>
                    <TableCell>Stream</TableCell>
                    <TableCell>Branch</TableCell>
                    <TableCell>Final Year</TableCell>
                    <TableCell>Family Income</TableCell>
                    <TableCell>PWD</TableCell>
                    <TableCell>Caste</TableCell>
                    <TableCell>Course Access</TableCell>
                    <TableCell>Started At</TableCell>
                    <TableCell>Completion</TableCell>
                    <TableCell>Completed At</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {tableLoading ? (
                    <TableRow>
                      <TableCell colSpan={17} align="center" sx={{ py: 8 }}>
                        <CircularProgress size={40} sx={{ color: "#1d4ed8" }} />
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5, fontWeight: 500 }}>
                          Loading student data...
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : paginatedTableData.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={17} align="center" sx={{ py: 8 }}>
                        <Typography variant="body1" color="text.secondary" fontWeight={500}>
                          No students found matching the selected criteria.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    paginatedTableData.map((row) => (
                      <TableRow key={row.internship_id} hover sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                        <TableCell sx={{ fontWeight: 600, color: "#1e293b" }}>{row.name}</TableCell>
                        <TableCell>{row.email || "N/A"}</TableCell>
                        <TableCell>
                          <Chip 
                            label={row.gender || "N/A"} 
                            size="small" 
                            sx={{ 
                              backgroundColor: row.gender?.toLowerCase() === "male" ? "rgba(59, 130, 246, 0.1)" : row.gender?.toLowerCase() === "female" ? "rgba(16, 185, 129, 0.1)" : "rgba(100, 116, 139, 0.1)",
                              color: row.gender?.toLowerCase() === "male" ? "#2563eb" : row.gender?.toLowerCase() === "female" ? "#059669" : "#475569",
                              fontWeight: 600,
                              textTransform: "capitalize",
                              borderRadius: "6px"
                            }} 
                          />
                        </TableCell>
                        <TableCell>{row.domain}</TableCell>
                        <TableCell>{row.state || "N/A"}</TableCell>
                        <TableCell>{row.city || "N/A"}</TableCell>
                        <TableCell>{row.institute || "N/A"}</TableCell>
                        <TableCell>{row.program || "N/A"}</TableCell>
                        <TableCell>{row.branch || "N/A"}</TableCell>
                        <TableCell>{row.year_of_passing || "N/A"}</TableCell>
                        <TableCell>{row.family_income ? `₹${Number(row.family_income).toLocaleString("en-IN")}` : "N/A"}</TableCell>
                        <TableCell>
                          <Chip 
                            label={String(row.is_pwd) === "1" || String(row.is_pwd).toLowerCase() === "yes" ? "Yes" : "No"} 
                            size="small" 
                            sx={{ 
                              backgroundColor: String(row.is_pwd) === "1" || String(row.is_pwd).toLowerCase() === "yes" ? "rgba(239, 68, 68, 0.1)" : "rgba(16, 185, 129, 0.1)",
                              color: String(row.is_pwd) === "1" || String(row.is_pwd).toLowerCase() === "yes" ? "#dc2626" : "#059669",
                              fontWeight: 600,
                              borderRadius: "6px"
                            }} 
                          />
                        </TableCell>
                        <TableCell>{row.caste || "N/A"}</TableCell>
                        <TableCell>
                          <Chip 
                            label={String(row.access_given) === "1" || String(row.access_given).toLowerCase() === "yes" || row.access_given === true ? "Access Given" : "Access Not Given"} 
                            size="small" 
                            sx={{ 
                              backgroundColor: String(row.access_given) === "1" || String(row.access_given).toLowerCase() === "yes" || row.access_given === true ? "rgba(16, 185, 129, 0.1)" : "rgba(239, 68, 68, 0.1)",
                              color: String(row.access_given) === "1" || String(row.access_given).toLowerCase() === "yes" || row.access_given === true ? "#059669" : "#dc2626",
                              fontWeight: 600,
                              borderRadius: "6px"
                            }} 
                          />
                        </TableCell>
                        <TableCell>{row.started_at ? formatDate(row.started_at) : "N/A"}</TableCell>
                        <TableCell>
                          <Chip 
                            label={String(row.is_completed) === "1" || row.is_completed === 1 || String(row.is_completed).toLowerCase() === "yes" || row.is_completed === true || String(row.is_completed).toLowerCase() === "completed" ? "Completed" : "Not-Completed"} 
                            size="small" 
                            sx={{ 
                              backgroundColor: String(row.is_completed) === "1" || row.is_completed === 1 || String(row.is_completed).toLowerCase() === "yes" || row.is_completed === true || String(row.is_completed).toLowerCase() === "completed" ? "rgba(16, 185, 129, 0.1)" : "rgba(239, 68, 68, 0.1)",
                              color: String(row.is_completed) === "1" || row.is_completed === 1 || String(row.is_completed).toLowerCase() === "yes" || row.is_completed === true || String(row.is_completed).toLowerCase() === "completed" ? "#059669" : "#dc2626",
                              fontWeight: 600,
                              borderRadius: "6px"
                            }} 
                          />
                        </TableCell>
                        <TableCell>{row.completed_at ? formatDate(row.completed_at) : "N/A"}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[10, 20, 30, 50]}
              component="div"
              count={totalCount}
              rowsPerPage={pageSize}
              page={tablePage}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              sx={{
                borderTop: "1px solid rgba(224, 224, 224, 1)",
                mt: 1,
              }}
            />
          </PremiumCard>
        )}
      </Container>
    </Fade>
  );
};

export default AdminStudentReport;
